const EntornoCard = ({ value }) => {

  return (
    <>
      <th scope="row">{value.idNodo}</th>
      <td>{value.lat}</td>
      <td>{value.lon}</td>
      <td>{value.CO}</td>
      <td>{value.CO2}</td>
      <td>{value.metanos}</td>
      <td>{value.humo}</td>
      <td>{value.vapores}</td>
      <td>{value.O3}</td>
      <td>{value.fecha}</td>
      <td>{value.hora}</td>
    </>
  )

}

export default EntornoCard